import React from "react";
import EntityTable from "../EntityTable";
import usePersonQuery from "../../hooks/query/usePersonQuery";
import { getPersonVersionsColumns } from "../../common/entities/PersonVersionsColumns";

interface PersonAssociatedVersionsTableProps {
  hidden?: boolean;
  personId: string;
  personalRole?: string;
  teamRole?: string;
  language?: string;
  showTeam?: boolean;
  showRole?: boolean;
}

const PersonAssociatedVersionsTable: React.FC<
  PersonAssociatedVersionsTableProps
> = ({
  personId,
  personalRole,
  teamRole,
  language,
  showTeam = false,
  showRole = false,
}) => {
  const { useFetchAssociatedVersions } = usePersonQuery();
  const { data, isLoading, errorMessage, pagination, setPagination } =
    useFetchAssociatedVersions(personId, { personalRole, teamRole, language });

  return (
    <EntityTable
      loading={isLoading}
      error={errorMessage}
      columns={getPersonVersionsColumns({ showTeam, showRole })}
      data={data?.data || []}
      pagination={pagination}
      manualPagination={true}
      onPaginationChange={setPagination}
      totalRowCount={data?.total || 0}
    />
  );
};

export default PersonAssociatedVersionsTable;
